var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import { UploadDropZone, UploadDropZoneStatus } from './UploadDropZone';
import { uploadFile } from '../apis/uploads';
export const PlatformProcessor = props => {
    const [status, setStatus] = React.useState(UploadDropZoneStatus.ReadyToUpload);
    const [fileName, setFileName] = React.useState();
    const onDrop = (acceptedFiles) => __awaiter(void 0, void 0, void 0, function* () {
        if (!props.accessToken) {
            if (props.onError) {
                props.onError(new Error('Access token is missing'));
            }
            return;
        }
        setStatus(UploadDropZoneStatus.Uploading);
        const { uploadTenant, provideThumbnails, deleteAfterDays } = props.uploadOptions || {};
        if (props.onUploadStart) {
            props.onUploadStart();
        }
        const pendingUploads = acceptedFiles.map(file => uploadFile(props.accessToken, file, uploadTenant || 'default', provideThumbnails, deleteAfterDays));
        try {
            const uploads = yield Promise.all(pendingUploads);
            setStatus(UploadDropZoneStatus.Processing);
            if (props.onUploadSuccess) {
                props.onUploadSuccess(uploads);
            }
            yield props.process(uploads);
            setFileName(uploads[0].uploadedFileName);
            setStatus(UploadDropZoneStatus.Processed);
        }
        catch (error) {
            setFileName(undefined);
            setStatus(UploadDropZoneStatus.ReadyToUpload);
            if (props.onError) {
                props.onError(error);
            }
        }
    });
    const handleDelete = () => {
        setStatus(UploadDropZoneStatus.ReadyToUpload);
        if (props.onDelete) {
            props.onDelete();
        }
    };
    return (React.createElement(UploadDropZone, { status: status, fileName: fileName, onDrop: onDrop, onDelete: handleDelete }));
};
//# sourceMappingURL=UploaderProcessor.js.map